<ng-select [ngModel]="multiple ? items : item"
           [items]="itemList"
           (ngModelChange)="onSelectionChange($event)"
           (change)="onChange($event)"
           [disabled]="disabled"
           [multiple]="multiple"
           [typeahead]="typeahead"
           [loading]="searching"
           [required]="required"
           [clearable]="clearable"
           [placeholder]="placeholder"
           appendTo="{{appendTo}}"
           [ngClass]="selectClass"
           bindLabel="name"
           name="company" id="company">
</ng-select>
